import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { requestSucceeded, requestFailed, requestStarted } from 'redux-request-state/util/requestStateCheckers';
import { getRequestStatesForKeys } from '../selectors/requestStates';
const requestPending = request => requestStarted(request) && !requestSucceeded(request);

/**
 * @param requestKeys
 * @returns Mutually exclusive parameters indicating requests state: isLoading, isError, hasSucceeded
 */
const useRequestState = requestKeys => {
  const requests = useSelector(state => getRequestStatesForKeys(state, requestKeys));
  const isError = requests.some(requestFailed);
  const isLoading = !isError && requests.some(requestPending);
  const hasSucceeded = !isLoading && requests.some(requestSucceeded);
  return useMemo(() => ({
    isError,
    isLoading,
    hasSucceeded
  }), [isError, isLoading, hasSucceeded]);
};
export default useRequestState;